import httpService from "./httpService";

const taskApi = {
 approveRejectTask: (subjectId, status) =>
  httpService.put(`/approve-status-update/${subjectId}`, { status })

};
export default taskApi;